module.exports = __webpack_public_path__ + "static/media/FOUR.f6e51d8b.png";